
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "SliderImagesBlock",

  data: function () {
    const unicIdPagination = [...Array(36)].map(() => Math.floor(Math.random() * 36).toString(36)).join('');
    const idNavigationLeft = `vacancy-event-card__button-navigation--prev-${ (Math.random() + 1).toString(36).substring(7) }`;
    const idNavigationRight = `vacancy-event-card__button-navigation--next-${ (Math.random() + 1).toString(36).substring(7) }`;
    return {
      unicIdPagination: unicIdPagination,
      idNavigationLeft: idNavigationLeft,
      idNavigationRight: idNavigationRight,
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 2,
        slidesPerGroup: 1,

        breakpoints: {
          1200: {
            spaceBetween: 20,
            slidesPerView: this.cfgs?.visible_count || 4,
            slidesPerGroup: this.cfgs?.visible_count || 4,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          860: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          640: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
          },
        },
        pagination: {
          el: `#slider-images-block-pagination-${ unicIdPagination }`,
          type: 'bullets',
          dynamicBullets: true
        },
        navigation: {
          prevEl: `#slider-images-block-navigation-prev-btn-${ idNavigationLeft }`,
          nextEl: `#slider-images-block-navigation-prev-btn-${ idNavigationRight }`
        },
      },
    }
  },

  components: {
    Swiper,
    SwiperSlide
  },

  methods: {
    openImages: function (index) {
      this.$store.commit("pop-up-images/setOpen", {
        images: (this.values.items || []).map((t) => t.image),
        activeIndex: index
      })
    },
  },
})
